import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
// import logoImage from '../assets/images/lws-logo-light.svg'
import logoImage from '../assets/images/project_manager_logo.png'
import Error from '../components/ui/Error'
import { useLoginMutation } from '../features/auth/authApi'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const [login, { data, isLoading, error: responseError }] = useLoginMutation()

  const navigate = useNavigate()

  useEffect(() => {
    if (responseError?.data) {
      setError(responseError.data)
    }
    if (data?.accessToken && data?.user) {
      navigate('/inbox')
    }
  }, [data, responseError, navigate])

  const handleSubmit = (e) => {
    e.preventDefault()

    setError('')

    login({
      email,
      password,
    })
  }

  return (
    <div className='grid place-items-center h-screen bg-[#F9FAFB'>
      <div className='min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8'>
        <div className='max-w-md w-full space-y-8'>
          <div>
            <Link to='/'>
              <img
                className='mx-auto h-20 w-auto'
                src={logoImage}
                alt='Learn with sumit'
              />
            </Link>
            <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
              Sign in to your account
            </h2>
          </div>
          <form className='mt-8 space-y-6' onSubmit={handleSubmit}>
            <div className='rounded-md shadow-sm -space-y-px'>
              <div>
                <label htmlFor='email-address' className='sr-only'>
                  Email address
                </label>
                <input
                  id='email-address'
                  name='email'
                  type='email'
                  autoComplete='email'
                  required
                  className='appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm'
                  placeholder='Email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor='password' className='sr-only'>
                  Password
                </label>
                <input
                  id='password'
                  name='password'
                  type='password'
                  autoComplete='current-password'
                  required
                  className='appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm'
                  placeholder='Password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type='submit'
                className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500'
                disabled={isLoading}
              >
                Sign in
              </button>
            </div>

            {error !== '' && <Error message={error} />}
          </form>
            <div>
              <button
                onClick={() => {setEmail('t1@t.co'); setPassword('1234')}}
                className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500'
                disabled={isLoading}
              >Test User-1</button>
            </div>

            <div>
              <button
                onClick={() => {setEmail('t2@t.co'); setPassword('1234')}}
                className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500'
                disabled={isLoading}
              >Test User-2</button>
            </div>

            <div>
              <button
                onClick={() => {setEmail('t3@t.co'); setPassword('1234')}}
                className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500'
                disabled={isLoading}
              >Test User-3</button>
            </div>
        </div>
      </div>
    </div>
  )
}
